import React, { useContext, useEffect,  useState } from 'react';
import AuthHeader from '../../commons/AuthHeader';
import AuthFooter from '../../commons/AuthFooter';
import { Button, ButtonVariant, IconName, ButtonIconAlign, Icon } from '@eightfold.ai/octuple';
import { globalContext } from '../../store';
import Api from '../../Api';
import { initialiseImmersiveAssessment } from '../../commons/commonFunctions';
import { useNavigate } from 'react-router-dom';
import { actionButtonStyle} from '../../commons/commonStyles';

const DownloadPDF = () => {
  const navigate = useNavigate();
  const { globalState, dispatch } = useContext(globalContext);
  const title = globalState?.clientData?.name;
  const immersiveAssessmentData = globalState?.immersiveAssessmentData;
  const [showLoader, setShowLoader] = useState(false);
  const [, setLeaderName] = useState<any>('');
  const [headerLogo, setHeaderLogo] = useState<string>('');
  const [, setHeaderImage] = useState<string>('');
  const [, setPrimaryColor] = useState<string>('#BA3A19');
  const [showDownloadCompleteBtn, setShowDownloadCompleteBtn] = useState<boolean>(false);
  const isBtnDisabled = immersiveAssessmentData?.assessmentStatus === 'N' && (immersiveAssessmentData?.prepWorkCompleted === false || immersiveAssessmentData?.prepWorkCompleted === undefined);
  const [disableContinueBtn, setDisableContinueBtn] = useState(isBtnDisabled ? true : false);
  const prepData = globalState?.immersiveAssessmentData?.prepData;

  useEffect(() => {
    const params = {globalState, dispatch, navigate, setLeaderName, setHeaderImage, setHeaderLogo, setPrimaryColor, title};
    initialiseImmersiveAssessment(params);
  }, []);

	const downloadPDF =()=>{
    const pdfUrlId: any = prepData?.preReadPdfAssetPath;
    setShowLoader(true);
    Api.downloadImmersivePdf(pdfUrlId).then((res: any) => {
      if (res?.success) {
        setShowLoader(false);
        setShowDownloadCompleteBtn(true);
        setDisableContinueBtn(false);
      } else {
        setShowLoader(false);
      }
    }).catch((err: any) => {
      setShowLoader(false);
      if (err?.code === 401 && err?.message === 'Unauthorized Access') {
        dispatch({
          type: "SET_SHOW_LOGOUT_MODAL",
          payload: true,
        });
      }
    });
	}

  const updatePrepCompletedFlag = () => {
    Api.updatePrepWorkCompletedFlag(globalState?.immersiveAssessmentData?.assessmentId).then((res: any) => {
      if (res?.success) {
        navigate('/immersive/PrepStepsCompletion');
      }
    })
  }

  return (
    <div className='mainWrapper'>
      <div className='innerWrapper'>
        <AuthHeader title={title} headerLogo={headerLogo} setLoader={setShowLoader} />
        <div className='middleWrapper'>
          <div className='leftTextWrapper'>
            <div>
              <Button
                text='Back to intro video'
                variant={ButtonVariant.Secondary}
                classNames='completedAssessmentButton'
                onClick={() => navigate('/immersive/IntroductoryVideo')}
                transparent={true}
                iconProps={{ path: IconName.mdiChevronLeft }}
                alignIcon={ButtonIconAlign.Left}
              />
            </div>
            <div className='textContainer'>
              <h1 className='textHeading'>Download and review briefing document</h1>
              <h2 className='textDescription'>You are required to click to download this PDF before you can continue to the assessment. </h2>
              <Button
                text='Continue'
                variant={ButtonVariant.Secondary}
                classNames={disableContinueBtn ? 'actionButton inactive' :'actionButton'}
                style={actionButtonStyle}
                onClick={updatePrepCompletedFlag}
                iconProps={{ path: IconName.mdiArrowRight }}
                alignIcon={ButtonIconAlign.Right}
                disabled={disableContinueBtn}
              />
            </div>
          </div>

          <div className='rightTextWrapper'>
            <div className='bgImageWrapper' style={{backgroundImage: `url(./../assets/img/immersiveBackground.svg)`}}>
              {/* <img src={`./../assets/img/immersiveBackground.svg`} className='BGImage' alt="background-image"/> */}
              <div className='contentOverlay'>
                <div className='Textcontent'>
                    <div className='textSection'>
                      <img src={'../../assets/img/immersivePDFDocIcon.svg'} alt='check List' className='cardIcon'/>
                      <div  className ='sectionContainer'>
                        <h3 className='sectionHeading' style={{marginBottom:'0px'}}>Download the briefing document</h3>
                        <div className='sectionDescription'>
                          <p className='sectionBriefing'>Review the document carefully, as the information will be crucial to your performance and decision-making during the experience.</p>
                        </div>
                      </div>
                       <div className='assessmentActionItems'>
                        <Button
                          text='Download PDF'
                          variant={ButtonVariant.Secondary}
                          classNames='actionButton'
                          style={actionButtonStyle}
                          onClick={() => {
                            downloadPDF();
                          }}
                          iconProps={showLoader ? { path: IconName.mdiLoading, spin: true } : {path:IconName.mdiArrowCollapseDown}}
                          alignIcon={ButtonIconAlign.Right}
                        />
                        {showDownloadCompleteBtn && <p className='actionInfo'>
                          <Icon path={IconName.mdiCheck} className='infoIcon' />
                          Download completed
                        </p>}
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AuthFooter />
      </div>
    </div>
  );
};

export default DownloadPDF;